import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ResourceComponentEntity } from '@/services/apis';

const initialState = {
  rolesResources: [],
  resourcesComponents: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0,
};

// RESOURCES
export const createNewMappingResource = createAsyncThunk('mapping/createNewResource', async (resoucesData: any) => {
  const data = await ResourceComponentEntity.createResourceComponent(resoucesData);
  return data;
});

export const fetchMappingResources = createAsyncThunk(
  'mapping/fetchMappingResources',
  async ({ page, rowsPerPage, app_id }: any) => {
    const response = await ResourceComponentEntity.fetchResourceComponents({ page, rowsPerPage, app_id });
    return response;
  },
);

export const deleteMappingComponentResource = createAsyncThunk('mapping/deleteMappingResource', async (resourceId: string) => {
  const response = await ResourceComponentEntity.deleteResourceComponent(resourceId);
  return response;
});

export const MappingSlice = createSlice({
  name: 'mapping',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMappingResources.pending, (state, action) => {
      return { ...state, resources: [], totalRecords: 0, loading: true };
    });
    builder.addCase(fetchMappingResources.fulfilled, (state, action) => {
      state.resourcesComponents = action.payload?.data;
      state.totalRecords = action.payload?.data?.length;
      state.loading = false;
    });
    builder.addCase(fetchMappingResources.rejected, (state) => {
      return { ...state, resources: [], totalRecords: 0, loading: false };
    });
  },
});

export const mappingSliceSelector = (state: any) => state.mapping;

export default MappingSlice.reducer;
